const getPreparedSlug = (id, preparedSitemapSimplify) => {
	const tilePageItem = preparedSitemapSimplify?.find((item) => item.pageId === id) || '';
	return tilePageItem?.linkToPage || '';
};

export default getPreparedSlug;
